import { useEffect, useReducer, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";
import { scrollToElement } from '../../lib/userFunctions';
import { useMutation } from "@tanstack/react-query";
import { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from 'react-toastify';
import Axios from 'axios';


const initialState = {
    title: '',
    content: '',
    video: "",
    openYn: 'N',
};

function videoReducer(state, action) {
    return { ...state, ...action };
}

const VideoForm = () => {
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const auth = useSelector(state => state.auth);
    const detailBook = useSelector(state => state.detailBook);
    const [state, setState] = useReducer(videoReducer, initialState);
    const [uploadPercent, setUploadPercent] = useState(0);
    const config = useSelector(state => state.config);
    const schoolData = useSelector(state => state.school);
    const videoRef = useRef();

    useEffect(() => scrollToElement('lnb'), []);

    const onUploadProgress = (progressEvent) => {
        setUploadPercent(Math.floor(progressEvent.loaded / progressEvent.total * 100));
    }


    const videoUploadMutate = useMutation({
        mutationFn: (data) => {
            return Axios.post('https://humac.kr:8443/HumacServiceServer/reading/youtube/create', data, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    'Content-Type': "multipart/form-data"
                },
                onUploadProgress: onUploadProgress
            });
        },
        onSuccess: (res) => {
            console.log(res);
            toast.success('등록되었습니다.\n관리자 확인 후 유튜브에 등록됩니다.');
            navigate(`/${school}/book/${isbn}`);
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            toast.error(`업로드중 오류가 발생했습니다. \n${errorData.message}`);
        }
    });

    const onStore = () => {
        if (videoUploadMutate.isPending) return;
        if (!auth.authenticated) {
            alert('로그인 후 이용해주세요.');
            return;
        }

        if (state.title === '') {
            alert('제목을 입력해주세요.');
            return;
        }

        if (!videoRef.current.value) {
            alert('영상을 선택해주세요.');
            return;
        }


        let formData = new FormData();
        formData.append('serviceCode', config.serviceCode);
        formData.append('schoolCode', schoolData.code);
        formData.append('schoolName', schoolData.name);

        formData.append('authToken', 'Bearer' + sessionStorage.getItem("user"));
        formData.append('user_id', auth.id);
        formData.append('userid', auth.userid);
        formData.append('userName', auth.name);

        formData.append('title', state.title);

        formData.append('isbn', isbn);
        formData.append('bookTitle', detailBook.book.title);
        formData.append('openYn', state.openYn);
        formData.append('video', videoRef.current.files[0]);

        setUploadPercent(0);
        videoUploadMutate.mutate(formData);
    }

    //  파일이름앞에 불필요한 경로 정보는 표시하지 않는다.
    const onChangeFileName = (event) => {
        let fileName = event.target.value.replace(/C:\\fakepath\\/i, "");
        setState({ video: fileName });
    }



    return (
        <div className="section book_video create create_video">
            <div className="guide_box">
                <div className="inner">
                    <div>
                        <ul className="bullet_list">
                            <li>동화구연, 책읽기, 책 소개, 토론, 다양한 독서활동을  '3분 이상의 영상' 으로 찍어보아요.</li>
                            <li className="warning"><i className="icon fas fa-exclamation-circle"></i>동화구현과 책읽기의 경우, 저작권 보호를 위해 유튜브 등록을 하지 않습니다.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="inner">
                <div className="creat_form">
                    <div className="create_video_area">
                        <div className="cont_row mgT0">
                            <h4>독서영상 제목</h4>
                            <input type="text" placeholder="내가 만든 독서영상의 이름을 만들어 주세요." value={state.title} name="title" onChange={e => setState({ title: e.target.value })} />
                        </div>
                        <div className="cont_row">
                            <h4>독서영상 올리기</h4>
                            <div className="attach_file">
                                <input type="text" className="file_name" readOnly="readonly" value={state.video} placeholder="선택된 파일 없음" />
                                <div className="btn_wrap">
                                    <input type="file" ref={videoRef} name="video" className="input_file" onChange={onChangeFileName} />
                                    <label className="btn _sm">파일 선택</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cont_row">
                        <div className="guide_box _upload">
                            <h4><i className="icon fas fa-exclamation-triangle"></i> '독서영상' 등록 시 확인사항</h4>
                            <ul className="bullet_list">
                                <li className="highlight">독서영상은 3분 이상 되어야 합니다. 3분 미만의 영상은 삭제됩니다.</li>
                                <li>독서영상은 다른 독서활동(독서퀴즈, 독서감, 독서화)과 달리 독서사과 2개를 획득할 수 있습니다.</li>
                                <li>독서영상은 '독서길라잡이' 유튜브 채널에 일부공개로 올라갑니다. 일부공개란 '독서길라잡이'에서만 볼 수 있음을 의미합니다.<br />* 유튜브에서도 검색해서 보려면 아래 '유튜브에서도 보고 싶어요.'를 체크하세요.</li>
                                <li>독서영상 등록과 삭제 처리시 요청일로부터 1~2일이 소요됩니다.</li>
                                <li>저작권 문제로 동화구현시 책표지만 보이게끔 읽어주세요.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="cont_row alignC">
                        <div className="input_check">
                            <input type="checkbox" name="openYn" id="openYn" checked={state.openYn === 'Y'} onChange={() => { setState({ openYn: state.openYn === 'Y' ? 'N' : 'Y' }) }} /><label htmlFor="openYn">유튜브에서 보고 싶어요.</label>
                        </div>
                    </div>

                    <div className="cont_row">
                        <div className="create_btn">
                            {videoUploadMutate.isPending &&
                                <div className="alignC">
                                    <img src={`${process.env.PUBLIC_URL}/static/images/common/ajax-loader.gif`} alt="" /> <br />
                                    {uploadPercent}%
                                </div>
                            }
                            <div className="bbs_btn alignC">
                                <button type="button" className="btn _turq" onClick={onStore}>저장</button>
                                <Link className="btn _red" to={`/${school}/book/${isbn}`}>닫기</Link>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}
export default VideoForm;